import { iBrowserStore } from './types'

const get = (id: string): string | null => {
  return window.localStorage.getItem(id)
}

const put = (id: string, value: string): string => {
  window.localStorage.setItem(id, value)

  return value
}

const configure = (id = 'lang'): iBrowserStore => ({
  get: (
    (id) => () =>
      get(id)
  )(id),
  put: (
    (id) => (value) =>
      put(id, value)
  )(id),
})

export { configure, get, put }
